module.exports = __webpack_public_path__ + "static/media/3.debfc222.jpg";